
import * as ACTION from "./addContactOptionActionTypes"

const initialState = {
    gettingContactLimit: false,
    leadSourceOptions: [],
    pipelineOptions: [],
    stageOptions: [],
    insuranceCompanyOptions: [],
    PolicyOptions: [],
}

const addContactReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case ACTION.GET_CONTACT_LIMIT:
      return {
        ...state, 
        gettingContactLimit: true
    }
    case ACTION.GET_CONTACT_LIMIT_SUCCESS:
        return {
            ...state, 
            gettingContactLimit: false, 
            leadSourceOptions: action.payload.sources ?? [],
            pipelineOptions: action.payload.pipelines ?? [],
            stageOptions: action.payload.stages ?? []
        }
    case ACTION.GET_CONTACT_LIMIT_FAILURE:
        return {
            ...state, 
            gettingContactLimit: false, 
            leadSourceOptions: [],
            pipelineOptions: [],
            stageOptions: []
        }
    case ACTION.GET_INSURANCE_COMPANIES_OPTION: {
      return {...state}
    }
    case ACTION.GET_INSURANCE_COMPANIES_OPTION_SUCCESS:
      return {
        ...state,
        insuranceCompanyOptions: action.payload ?? []
      }
    case ACTION.GET_INSURANCE_COMPANIES_OPTION_FAILURE:
      return {
        ...state,
        insuranceCompanyOptions: []
      }
    case ACTION.GET_POLICY_OPTION: {
      return {...state}
      }
    case ACTION.GET_POLICY_OPTION_SUCCESS:
      return {
        ...state,
        PolicyOptions: action.payload ?? []
      }
    case ACTION.GET_POLICY_OPTION_FAILURE:
      return {
        ...state,
        PolicyOptions: []
      }

    default:
      return state
  }
}

export default addContactReducer
